import { render, staticRenderFns } from "./TableMask.vue?vue&type=template&id=2b376cfe"
import script from "./TableMask.vue?vue&type=script&lang=js"
export * from "./TableMask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports